import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unsaved-changes',
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrls: ['./unsaved-changes-dialog.component.scss'],
})
export class UnsavedChangesDialogComponent implements OnInit {
  @Output()
  leavePageEvent = new EventEmitter<boolean>();

  constructor(
    private dialogRef: MatDialogRef<UnsavedChangesDialogComponent, boolean>,
  ) {}

  ngOnInit(): void {}

  submit(leavePage: boolean): void {
    this.dialogRef.close(leavePage);
  }
}
